module.exports = __webpack_public_path__ + "img/Johto4.c88fcbd7.png";